
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContextMessageParentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageAction"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageSubject"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageBody"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageAuthor"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EscalatedMessage"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postTime"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForumReplyMessage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solution"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptedSolutionMessage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solution"},"arguments":[],"directives":[]}]}}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("./ContextMessageAction.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageSubject.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageBody.fragment.graphql").definitions));


    module.exports = doc
  
